import { render, staticRenderFns } from "./HistoriaClinicaCard.vue?vue&type=template&id=0b3bc1ea&"
import script from "./HistoriaClinicaCard.vue?vue&type=script&lang=js&"
export * from "./HistoriaClinicaCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports